import React, { PureComponent } from 'react';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import withSizes from 'react-sizes';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Cookie from 'js-cookie'
import { beginBookingManagementProcess, openModal, updateProduct, closeModal  } from '../../redux/actions';
import { axiosInstance, objectIsEmpty } from '../../utils';

import {
  Container,
  Image,
  ProductHeader,
  ListContainer,
  More,
  UpgradeButton,
  Info,
  ImageWrapper,
} from './styles';

const mapDispatchToProps = dispatch => bindActionCreators({
  beginManagementProcess: beginBookingManagementProcess,
  handleModalOpen: openModal,
  updateUserProduct: updateProduct,
  closeUpgradeModal: closeModal,
}, dispatch);

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 768,
});

const mapStateToProps = state => ({
  hotel: state.userProduct.hotel,
  userProduct: state.userProduct,
  userData: state.user.userData,
  date: state.userPreferences.date,
  guests: state.userPreferences.guests,
  promo: state.promo,
});

@connect(mapStateToProps, mapDispatchToProps)
@withSizes(mapSizesToProps)
class UpgradeCard extends PureComponent {

  static propTypes = {
    multi: PropTypes.bool,
    hotel: PropTypes.instanceOf(Object),
    name: PropTypes.string,
    product: PropTypes.instanceOf(Object),
    id: PropTypes.number,
    userProduct: PropTypes.instanceOf(Object),
    userData: PropTypes.instanceOf(Object),
    promo: PropTypes.instanceOf(Object),
    updateUserProduct: PropTypes.func,
    closeUpgradeModal: PropTypes.func,
    date: PropTypes.string,
    image: PropTypes.string,
    maxGuests: PropTypes.number,
    isMobile: PropTypes.bool,
    guests: PropTypes.oneOf([PropTypes.string, PropTypes.number]),
    upgradeList: PropTypes.oneOf([null, PropTypes.instanceOf(Array)]),
  };

  state = {
    wasOpened: false,
    isOpened: false,
    extraPayment: null,
    priceObject: null,
    priceLoaded: null,
  };

  async componentDidMount() {
    const { id, date, maxGuests, guests, promo } = this.props;
    const { getTotalAfterPromo, addTaxToTotal } = this;
    const numericId = Number(id);

    // Negative/invalid placeholder IDs (e.g. onboarding preview products) can't
    // be priced by the standard endpoint; leave the card in its disabled
    // (unpriced) state rather than letting a 404 become an unhandled rejection.
    if (!Number.isInteger(numericId) || numericId < 0) {
      return;
    }

    try {
      const { data: price } = await axiosInstance.get(`products/price_with_tax/${id}?date=${moment(date).format('YYYY-MM-DD')}`);
      const { discountName, oldPrice, price: newPrice, tax, rate, total, oldTotal } = price;
      const prodAmount = Math.ceil(guests/maxGuests);
      const totalAfterPromo = promo.status === 'success' ? getTotalAfterPromo(total, prodAmount) : total * prodAmount;

      const extraPayment = addTaxToTotal(totalAfterPromo, rate) - this.calculatePriceOfUpgradableProd();

      const priceObject = {
        discountName,
        newPrice: newPrice.toFixed(2),
        oldPrice: oldPrice.toFixed(2),
        tax,
        rate,
        total,
        oldTotal
      };

      this.setState({priceObject, priceLoaded: true, extraPayment})
    } catch (e) {
      this.setState({ priceLoaded: false });
    }
  };

  handleOpen = () => {
      this.setState(prevState => ({
        isOpened: !prevState.isOpened,
      }));
  };

  upgrade = async () => {
   const { hotel, name, product, userProduct, updateUserProduct, closeUpgradeModal, formFunc, formData } = this.props;

     /* const { priceObject } = this.state;

  

    const { name: hotelName } = hotel;

    const productObj = {
      ...product,
      price: priceObject,
    };

    const newProdObj = {
      ...userProduct,
      product: productObj,
    };

    localStorage.setItem('userSession', JSON.stringify({
      ...newProdObj,
      sessionExp: new Date(Date.now() + (5 * 60 * 1000)),
    }));

    Cookie.set('userSession', JSON.stringify({productName: name, hotelName}), { path: '/' });

    formFunc(formData, 'checkout'); */
    await updateUserProduct(name);
    closeUpgradeModal();

  };

  calculatePriceOfUpgradableProd = () => {
    const { getTotalAfterPromo, addTaxToTotal } = this;
    const { promo, userProduct: { product: { price: { total, rate } } }, guests, userData, date} = this.props;
    const guestsAfterSubCheck = userData && !objectIsEmpty(userData.subscription) && !userData.last24freeDayPass && moment(date).isBefore(moment().add(1, 'day')) ? guests - 1 : guests;
    const totalAfterPromo = promo.status === 'success' ? getTotalAfterPromo(total, guestsAfterSubCheck) : total * guestsAfterSubCheck;

    return addTaxToTotal(totalAfterPromo, rate);
  };

  getTotalAfterPromo = (total, guestAmount) => {
    const { promo } = this.props;
    const initialPrice = guestAmount * total;

    const {
      info: {
        type: promoType,
        amount: promoAmount,
      }
    } = promo;

    switch (Number(promoType)) {
      case 0:
        return (initialPrice * ((100 - promoAmount) / 100)).toFixed(2);
      case 1:
        return initialPrice - promoAmount >= 0 ? (initialPrice - promoAmount).toFixed(2) : 0;
      default:
        return initialPrice.toFixed(2);
    }
  };

 renderUpgradeList = (isOpened, multi, description, upgradeListAsArray) => {
  if(isOpened) {
    return (
      <React.Fragment>
        <div dangerouslySetInnerHTML={{__html: description}} />             
        {description ? (<More type='button' onClick={this.handleOpen} isOpened={isOpened}>{isOpened ? 'Hide' : 'View'} more</More>) : null }
      </React.Fragment>
    )
  }
  
  const newList = upgradeListAsArray.filter( val=> val.length > 1);
  return ( 
    <React.Fragment>
      <ul multi={multi}>
        {newList.map(e => (<li multi={multi}>{e}</li>))}
      </ul>
      {description ? (<More type='button' onClick={this.handleOpen} isOpened={isOpened}>{isOpened ? 'Hide' : 'View'} more</More>) : null }
    </React.Fragment>
  )
 }

  addTaxToTotal = (total, rate) => Number(total) + (rate * total);

  render() {
    const { handleOpen, upgrade } = this;
    const { isOpened, priceLoaded, extraPayment } = this.state
    const { multi, image, name, maxGuests, isMobile, upgradeList, description } = this.props;
    const upgradeListAsArray = upgradeList !== null && typeof upgradeList !== 'undefined' ? upgradeList.split(';') : null;

    return (
      <Container multi={multi}>
        <ImageWrapper multi={multi} extra={extraPayment} blur={!priceLoaded}>
          <Image src={`${process.env.CDN_URL}${image}`} multi={multi} extra={extraPayment} blur={!priceLoaded} alt={name} />
        </ImageWrapper>
        <Info multi={multi}>
          <ProductHeader>
            {name}
            <br />
            <span>
              ({maxGuests} guests)
            </span>
          </ProductHeader>
          <ListContainer>
            <div className="scrollList">
              {upgradeListAsArray ? this.renderUpgradeList (isOpened,multi, description, upgradeListAsArray) : ''}
              
            </div>
            <UpgradeButton 
              type='button' 
              upgradeList={upgradeList}
              multi={multi} 
              btnType="primary" 
              onClick={upgrade} 
              disabled={!priceLoaded}
            >
              Upgrade
            </UpgradeButton>
          </ListContainer>
        </Info>
      </Container>
    );
  }
}

export default UpgradeCard;
